"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when an marking assignment exam question returns not found error
 * @param {string} message the validation message
 */
class MarkExamQuestionNotFoundError extends client_library_1.ExtendableError {
    constructor(errorCode) {
        super(`mark assignment exam question failed validation. ${errorCode}`);
    }
}
exports.default = MarkExamQuestionNotFoundError;
//# sourceMappingURL=MarkExamQuestionNotFoundError.js.map